// ** MUI Imports
import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'

import { CardHeader } from '@mui/material'

import { valueFormUSDWithoutDecimalsForNonGrid } from '../../common/commonFunctions'
import GaugeChart from 'react-gauge-chart'
import { Fragment } from 'react'
import { appColor } from '../../common/constants'


const RiskKPI = ({ kpi, riskPercent = 0 }: any) => {
 

  const renderLp = () => {
    return kpi.map((data: any, index: number) => (
      <div
        className={`d-flex justify-content-start col row ps-0  ${index === 0 ? 'ms-3' : 'ms-1'}`}
        key={`${data?.typeOfData + index}`}
      >
        <Card
          className=''
          sx={{
            borderColor: 'rgba(0,0,0,0.08)',
            borderRadius: 2,
            borderLeft: `6px solid  ${appColor} !important`
          }}
        >
          {data?.isParent ? (
            <>
              

              <CardContent className='p-0 pe-1 d-flex justify-content-between align-items-center mt-1'>
                <div
                  className={`d-flex justify-content-between col ${
                    data?.typeOfData === 'adjustment' || data?.typeOfData === 'trading'
                      ? 'flex-column justify-content-between'
                      : 'flex-row '
                  }`}
                >
                  {data?.typeOfData === 'adjustment' && (
                    <>
                      <div className='d-flex flex-column align-items-center justify-content-between' key={data.label}>
                        <div className='d-flex flex-row mt-1 align-items-center w-100 justify-content-between'>
                          <Typography fontSize={'1rem'} className='text-nowrap justify-content-start'>
                            {data.label}
                          </Typography>
                          <Typography
                            fontSize={'1rem'}
                            fontWeight={600}
                            className='justify-content-end'
                            color={data.valueColor}
                            fontFamily={'Cairo'}
                          >
                            {valueFormUSDWithoutDecimalsForNonGrid(data.value)}
                          </Typography>
                        </div>
                      </div>
                    </>
                  )}
                  {data?.typeOfData === 'adjustment' &&
                    data?.children?.map((childKpi: any, childIndex: number) => {
                      return (
                        <div
                          className='d-flex flex-column align-items-center justify-content-between'
                          key={`${childKpi.label + childIndex}`}
                        >
                          <div className='d-flex flex-row mt-1 align-items-center w-100 justify-content-between'>
                            <Typography fontSize={'1rem'} className='text-nowrap justify-content-start'>
                              {childKpi.label}
                            </Typography>
                            <Typography fontSize={'1rem'} fontWeight={600} fontFamily={'Cairo'} className='justify-content-end'>
                              {childKpi.value}
                            </Typography>
                          </div>
                        </div>
                      )
                    })}

                  {data?.typeOfData === 'trading' &&
                    data?.children?.map((childKpi: any, tradeIndex: number) => {
                      return (
                        <Fragment key={`${childKpi.label}-${tradeIndex}`}>
                          {(tradeIndex == 0 || tradeIndex == 1) && (
                            <>
                              <div className='d-flex flex-column align-items-center justify-content-between'>
                                <div className='d-flex flex-row mt-1 align-items-center w-100 justify-content-between'>
                                  <Typography fontSize={'1rem'} className='text-nowrap justify-content-start'>
                                    {childKpi.label}
                                  </Typography>
                                  <Typography fontSize={'1rem'} fontWeight={600} fontFamily={'Cairo'} className='justify-content-end'>
                                    {childKpi.value}
                                  </Typography>
                                </div>
                              </div>
                            </>
                          )}
                          <div className='d-flex flex-row' style={{ flexDirection: 'row' }}>
                            {childKpi.label === 'Borrows' && (
                              <>
                                <div className='d-flex flex-row mt-1 align-items-center justify-content-between w-100'>
                                  <div className='d-flex flex-row justify-content-between w-100'>
                                    <Typography fontSize={'1rem'} className='text-nowrap justify-content-start'>
                                      Borrows
                                    </Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600} fontFamily={'Cairo'} className='justify-content-end'>
                                      {childKpi.value}
                                    </Typography>
                                  </div>
                                  <div className='d-flex flex-row justify-content-between w-100 ms-2'>
                                    <Typography fontSize={'1rem'} className='text-nowrap justify-content-start'>
                                      Loans
                                    </Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600} fontFamily={'Cairo'} className='justify-content-end'>
                                      {childKpi.value}
                                    </Typography>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </Fragment>
                      )
                    })}
                </div>
              </CardContent>
            </>
          ) : (
            <>
              <CardContent className='p-0 pe-1 d-flex justify-content-between align-items-center mt-1'>
                <div className='d-flex flex-row mt-3 align-items-center' key={index}>
                 
                  <div className='d-flex flex-column'>
                    <Typography fontSize={'1rem'} fontWeight={600} fontFamily={'Cairo'} className='pb-2' color={data.valueColor}>
                      {valueFormUSDWithoutDecimalsForNonGrid(data.value)}
                    </Typography>
                    <Typography
                      fontSize={'1rem'}
                      className='text-nowrap'

                     
                    >
                      {data.label}
                    </Typography>
                  </div>
                </div>
              </CardContent>
            </>
          )}
        </Card>
      </div>
    ))
  }

 

  return (
    <div className='row px-0' style={{ width: '100.5%' }}>
      <div className='d-flex row col'>{renderLp()}</div>
      <div className='col-1 ps-1 pe-0'>
        <Card>
          <CardHeader
            className='p-0'
            subheader={
              <Typography
                fontSize={'small'}
                className='d-flex pt-1 ps-2'
              >
                Risk Percentage
              </Typography>
            }
          ></CardHeader>
          <CardContent className='p-0 pe-1 d-flex justify-content-between'>
            <GaugeChart
              id='gauge-chart1'
              nrOfLevels={3}
              colors={['green', '#FFC371', '#FF5F6D']}
              arcWidth={0.3}
              needleScale={0.4}
              percent={riskPercent}
              textColor='black'
            />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}

export default RiskKPI
